module.exports = __webpack_public_path__ + "static/media/HPNM01.cc324118.jpg";